<template>
  <div class="popup-overlay">
    <div class="alert-popup-container animated zoomIn">
      <div :class="['alert-popup', alert.type == 'err' ? 'err-pink' : 'err-default']" v-for="alert in fit20.alerts">
        {{ alert.msg }}
        <div v-if="alert.type === 'confirmation'" class="confirmation-buttons">
          <img @click="confirmAction(alert)" class="new-session-btn" width="50px"
            :src="fit20.storageBaseUrl + '/static/icons/save.png'">
          <img :src="fit20.storageBaseUrl + '/static/icons/x.png'" width="50px" @click="closeAlert(alert.id)" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: 'Alert',
  props: ["fit20", "closeAlert"],
  data() {
    return {

    };
  },
  methods: {
    confirmAction(alert) {
      if (alert.onConfirm) {
        alert.onConfirm(); // Execute the onConfirm function
      }
      this.closeAlert(alert.id); // Close the popup after confirming
    }
  },
  created: async function () {

  }
};
</script>

<style>
.alert-popup-container {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  z-index: 9999999999999999;
  border: none !important;
}

.alert-popup {
  position: relative;
  width: 60%;
  color: white;
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
}

.err-pink {
  background-color: #cb061d;
}

.err-orange {
  background-color: var(--fit20-orang);
}

.err-default {
  background-color: white;
  border: solid 2px var(--fit20-green);
  color: var(--fit20-gray);
}

.confirmation-buttons {
  margin-top: 20px;
  text-align: center;
}

.confirmation-buttons img {
  margin-left: 30px;
}

/* .error-popup img {
  width: 15px;
  position: absolute;
  top: 10px;
  right: 10px;
} */
</style>
